import { createSlice } from '@reduxjs/toolkit';

export const dashboardFailedPaymentsSlice = createSlice({
  name: 'dashboardFailedPayments',
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {
    getDashboardFailedPayments: () => {},
    setDashboardFailedPaymentsLoading: (state) => ({ ...state, loading: true }),
    setDashboardFailedPaymentsData: (state, action) => ({ ...state, loading: false, data: action.payload }),
    setDashboardFailedPaymentsError: (state, action) => ({ ...state, loading: false, error: action.payload }),
  },
});

export const {
  setDashboardFailedPaymentsData,
  setDashboardFailedPaymentsError,
  setDashboardFailedPaymentsLoading,
  getDashboardFailedPayments,
} = dashboardFailedPaymentsSlice.actions;

export default dashboardFailedPaymentsSlice.reducer;
